import {selectState, State} from '@ispm-client/modules/pathways/store';
import {createSelector, MemoizedSelector} from '@ngrx/store';


const getPreFetchState = (state: State): any => state.pathwaysIsPrefetched;

export const selectPrefetchDataEnabledOnPathwayTest: MemoizedSelector<object, boolean> = createSelector(
  selectState,
  getPreFetchState);



